import { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { cardsData } from "./OntologySection.config";

export const useOntologyCarousel = () => {
  const [activeCardId, setActiveCardId] = useState(1);

  // Embla carousel for mobile
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "center",
    containScroll: "trimSnaps",
    loop: false,
  });

  // Sync activeCardId with embla selected index
  useEffect(() => {
    if (!emblaApi) return;

    const onSelect = () => {
      const selectedIndex = emblaApi.selectedScrollSnap();
      const selectedCard = cardsData[selectedIndex];
      if (selectedCard) {
        setActiveCardId(selectedCard.id);
      }
    };

    emblaApi.on("select", onSelect);
    onSelect(); // Set initial

    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi]);

  // Sync embla scroll when activeCardId changes (for desktop clicks)
  useEffect(() => {
    if (!emblaApi) return;

    const currentIndex = cardsData.findIndex(
      (card) => card.id === activeCardId
    );
    if (currentIndex !== -1 && emblaApi.selectedScrollSnap() !== currentIndex) {
      emblaApi.scrollTo(currentIndex);
    }
  }, [activeCardId, emblaApi]);

  return {
    emblaRef,
    activeCardId,
    setActiveCardId,
  };
};

